<template>
    <div>
        <div class="input-group input-group-sm mb-2" v-for="language in languages">
            <div class="input-group-prepend">
                <span class="input-group-text" :title="language.name">
                    <img :src="'/static/flags/4x3/'+ language.key + '.svg'" class="flag-icon" :alt="language.name">
                </span>
            </div>
            <input type="text"
                   class="form-control"
                   v-model.lazy="values[language.key]"
                   v-on:change="saveTranslate(language.key)"
            >
        </div>
    </div>
</template>

<script>
    import DataGrid from '../../../core/DataGrid/DataGrid'

    export default {
        components: {
            DataGrid
        },
        props: {
            type: {
                type: String,
                required: true,
            },
            locales: {
                type: Array,
                required: true,
            },
            translateId: {
                type: Number,
                required: true,
            }
        },
        watch: {
            locales() {
                this.initValues();
            }
        },
        mounted() {
            this.initValues();
        },
        computed: {
            languages() {
                return process.env.translator.translatorLanguages[this.type];
            }
        },
        methods: {
            initValues() {
                this.values = {};
                this.locales.forEach(item => {
                    this.values[item.lang] = item.value;
                });
            },
            saveTranslate(locale) {
                this.$store.dispatch('translate/updateTranslate', {
                    translateId: this.translateId,
                    lang: locale,
                    value: this.values[locale],
                });
            }
        },
        data() {
            return {
                values: {}
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/admin/Pages/StaticText/StaticTextInput.vue